import axios from 'axios';
import { CustomField } from 'views/feed-management/features/customers/types/custom-field.type';
import { CustomerProducts } from 'views/feed-management/features/customers/types/customer-products.type';
import { Customer } from 'views/feed-management/features/customers/types/customer.type';

// GET
// Returns list of companies.
// /ewosapi/v1/bestmix/customer
export const getFeedManagementCustomers = async (): Promise<Customer[]> => {
  const res = await axios.get<Customer[]>(`/ewosapi/v1/bestmix/customer`);
  return res.data;
};

// GET
// /ewosapi/v1/bestmix/company/{globalCompanyId}/product/customfields
// Returns products custom fields.
export const getFeedManagementCustomerProductCustomFields = async (globalCompanyId: string): Promise<CustomField[]> => {
  const res = await axios.get<CustomField[]>(`/ewosapi/v1/bestmix/company/${globalCompanyId}/product/customfields`);
  return res.data;
};

// GET
// Returns products for company.
// /ewosapi/v1/bestmix/company/{globalCompanyId}/product
export const getFeedManagementCustomerProducts = async (globalCompanyId: string): Promise<CustomerProducts> => {
  const res = await axios.get<CustomerProducts>(`/ewosapi/v1/bestmix/company/${globalCompanyId}/product`);
  return res.data;
};
